import { deflate, inflate } from "pako";
import { base64ToBytes, bytesToBase64 } from "byte-base64";
import { identity } from "lodash";
import { util } from "./util";
// Simple hash function
// By: User bryc on StackOverflow, https://stackoverflow.com/a/52171480
// Licence: CC BY-SA 4.0
function cyrb53(str, seed = 0) {
    let h1 = 0xdeadbeef ^ seed, h2 = 0x41c6ce57 ^ seed;
    for (let i = 0, ch; i < str.length; i++) {
        ch = str.charCodeAt(i);
        h1 = Math.imul(h1 ^ ch, 2654435761);
        h2 = Math.imul(h2 ^ ch, 1597334677);
    }
    h1 = Math.imul(h1 ^ (h1 >>> 16), 2246822507);
    h1 ^= Math.imul(h2 ^ (h2 >>> 13), 3266489909);
    h2 = Math.imul(h2 ^ (h2 >>> 16), 2246822507);
    h2 ^= Math.imul(h1 ^ (h1 >>> 13), 3266489909);
    return 4294967296 * (2097151 & h2) + (h1 >>> 0);
}
function is_json_string(s) {
    return ['{', '['].indexOf(s.charAt(0)) >= 0;
}
export var ExportImport;
(function (ExportImport) {
    var compose = util.compose;
    var cleanedJSON = util.cleanedJSON;
    function with_type(type, version) {
        return (value) => {
            return {
                payload_type: "typed",
                type: type,
                version: version,
                value: value
            };
        };
    }
    function as_payload(compress = true, hash = true) {
        return (value) => {
            let p = {
                payload_type: "envelop",
                value: cleanedJSON(value)
            };
            if (compress) {
                p.value = bytesToBase64(deflate(p.value));
                p.compressed = true;
            }
            if (hash) {
                p.hash = cyrb53(p.value);
            }
            return p;
        };
    }
    function as_string(obj) {
        return btoa(cleanedJSON(obj));
    }
    function exp(type_info = null, compress = false, hash = false) {
        return compose(type_info ? (with_type(type_info.type, type_info.version)) : identity, // Wrap into typed if type info is given
        compress || hash ? as_payload(compress, hash) : identity, // Wrap into envelop if it is either compressed or hashed
        as_string);
    }
    ExportImport.exp = exp;
    function imp(type_info = null) {
        const from_string = (s) => {
            if (typeof s == "string")
                return is_json_string(s) ? JSON.parse(s) : JSON.parse(atob(s));
            else
                return s;
        };
        const extract_envelop = (o) => {
            if (o?.payload_type == "envelop") {
                let envelop = o;
                if (envelop.hash != null && cyrb53(envelop.value) != o.hash)
                    throw new Error();
                if (envelop.compressed)
                    return JSON.parse(inflate(base64ToBytes(o.value), { to: 'string' }));
                else
                    return JSON.parse(o.value);
            }
            return o;
        };
        const extract_typed = (o) => {
            if (o?.payload_type == "typed") {
                let envelop = o;
                let version = envelop.version;
                let value = envelop.value;
                while (type_info?.migrations) {
                    let migration = type_info.migrations.find((e) => e.from == version);
                    if (!migration)
                        break;
                    value = migration.f(value);
                    version = migration.to;
                }
                if (type_info && envelop.type != type_info.expected_type || version != type_info.expected_version)
                    throw new Error();
                return value;
            }
            return o;
        };
        return (s) => {
            try {
                return compose(from_string, extract_envelop, extract_typed)(s);
            }
            catch (e) {
                console.error(e);
                return null;
            }
        };
    }
    ExportImport.imp = imp;
})(ExportImport || (ExportImport = {}));
/*

export function export_to_object<T>(type: string,
                                    version: number,
                                    compress: boolean = true): (value: T) => hashed_payload {


    return (value: T): hashed_payload => {
        let typed: typed_value<T> = {
            type: type,
            version: version,
            value: value
        }

        let string = JSON.stringify(typed)

        return {
            hash: cyrb53(string),
            value: string
        }
    }
}

export function export_string<T>(type: string, version: number, value: T): string {
    let obj = JSON.stringify({
        type: type,
        version: version,
        value: value
    })

    return btoa(JSON.stringify({
        hash: cyrb53(obj),
        value: obj
    }))
}

export function import_object<T>(expected_type: string, expected_version: number, o: {
    hash: number,
    value: string
}): T {

    if (cyrb53(o.value) != o.hash) throw new Error()

    let o2: {
        type: string,
        version: number,
        value: T
    } = JSON.parse(o.value)

    if (o2.type != expected_type || o2.version != expected_version) throw new Error()

    return o2.value
}

export function import_string<T>(expected_type: string, expected_version: number, str: string): T {
    let o: {
        hash: number,
        value: string
    } = JSON.parse(atob(str))

    if (cyrb53(o.value) != o.hash) throw new Error()

    let o2: {
        type: string,
        version: number,
        value: T
    } = JSON.parse(o.value)

    if (o2.type != expected_type || o2.version != expected_version) throw new Error()

    return o2.value
}*/ 
